const BQ_CLICKED_GUEST_HOMEPAGE_CATEGORY_IMAGE = 'clicked_guest_homepage_category_image';
const BQ_CLICKED_HOMEPAGE_LO_SEARCH_TAG = 'clicked_homepage_lo_search_tag';
const BQ_CLICKED_HOMEPAGE_LO_GET_STARTED = 'clicked_homepage_lo_get_started';
const BQ_CLICKED_HOMEPAGE_LO_BUSINESS_SERVICES = 'clicked_homepage_lo_business_services';
const BQ_CLICKED_BRAND_VIDEO_PREVIEW = 'clicked_on_brand_campaign_thumbnail_video';
const BQ_SHOW_BRAND_VIDEO_PLAYER = 'brand_campaign_video_player_show';
const BQ_SHOW_BRAND_VIDEO_THUMBNAIL = 'brand_campaign_video_thumbnail_show';
const BQ_CLOSED_BRAND_VIDEO_PLAYER = 'closed_brand_campaign_video_player';
const BQ_CLICKED_BRAND_LANDING_PAGE_LINK = 'brand_campaign_landing_page_click';

const BQ_CLICKED_POPULAR_SERVICES_CAROUSEL = 'clicked_on_popular_services_carousel';
const BQ_CLICKED_GETTING_STARTED = 'clicked_on_getting_started';
const BQ_CLICKED_TESTIMONAILS_VIDEO = 'clicked_on_testimonials_video';
const BQ_CLICKED_CTA_BANNER = 'clicked_on_CTA_banner';
const BQ_CLICKED_QUALITY_EXPERTS_BANNER = 'clicked_on_quality_experts_banner';
const BQ_CLICKED_USPSS_BUTTON = 'clicked_on_uspss_button';
const BQ_HOMEPAGE_CLICK = 'Home_page_click';
const BQ_HOMEPAGE_IMP = 'Home_page_impression';

const BQ_HOVERED_USP = 'hovered_on_USPs';
const BQ_HOVERED_TESTIMONIALS_VIDEO = 'hovered_on_testimonials_video';

const BQ_IMP_TOP_BANNER_IS_SHOWN = 'top_banner_is_shown';
const BQ_IMP_POPULAR_SERVICES_CAROUSEL_IS_SHOWN = 'popular_services_carousel_is_shown';
const BQ_IMP_CATEGORY_ICONS_IS_SHOWN = 'category_icons_is_shown';
const BQ_IMP_GETTING_STARTED_IS_SHOWN = 'getting_started_is_shown';
const BQ_IMP_USPSS_IS_SHOWN = 'uspss_is_shown';
const BQ_IMP_LOHP_VIDEO_IS_SHOWN = 'lohp_video_is_shown';
const BQ_IMP_FIP_IS_SHOWN = 'fip_banner_is_shown';
const BQ_IMP_TESTIMONIALS_IS_SHOWN = 'testimonals_is_shown';
const BQ_IMP_GUIDES_IS_SHOWN = 'guides_is_shown';
const BQ_IMP_CTA_BANNER_IS_SHOWN = 'cta_banner_is_shown';
const BQ_IMP_QUALITY_EXPERTS_BANNER_IS_SHOWN = 'quality_experts_banner_is_shown';

const BQ_VIDEO_PLAY = 'video_play';
const BQ_VIDEO_PAUSE = 'video_pause';
const BQ_POPULAR_SERVICE_CLICK_WEBSITE_DEVELOPMENT = 'website-development-header-click';
const BQ_POPULAR_SERVICE_CLICK_ARCHITECTURE_AND_INTERIOR = 'Architecture-and-interior-header-click';
const BQ_POPULAR_SERVICE_CLICK_VIDEO_EDITING = 'video-editing-header-click';
const BQ_POPULAR_SERVICE_CLICK_NO_CODE = 'no-code-header-click';
const BQ_POPULAR_SERVICE_CLICK_BOOK_PUBLISHING = 'book-publishing-header-click';
const BQ_POPULAR_SERVICE_CLICK_LOGO_DESIGN = 'logo-design-header-click';
const BQ_POPULAR_SERVICE_CLICK_PRESENTATIONS_DESIGN = 'presentations-design-header-click';
const BQ_POPULAR_SERVICE_CLICK_VIDEO_UGC = 'video-ugc-header-click';
const BQ_POPULAR_SERVICE_CLICK_TIKTOK_SHOP = 'tiktok-shop-header-click';
const BQ_POPULAR_SERVICE_CLICK_AI_AUTOMATION = 'ai-automation-header-click';

const BQ_CLICKED_QUICK_SEARCH_SUGGESTION = 'clicked_on_quick_search_suggestion';
const BQ_CLICKED_TRENDING_SUGGESTION = 'clicked_on_trending_suggestion';
const BQ_FOCUS_IN_HERO_SEARCH_BOX = 'focus_in_hero_search_box';
const BQ_LOHP_TEST_VIEW = 'homepage.logged_out_test_view';

const BQ_CLICKED_NAV_BAR_LINK = 'clicked_on_nav_bar_link';
const BQ_VIEWED_NAV_BAR = 'viewed_nav_bar';
const BQ_VIEWED_BUILD_DESIGN_MARKET_SECTION = 'viewed_build_design_market_section';
const BQ_CLICKED_BUILD_DESIGN_MARKET_SECTION = 'clicked_on_build_design_market_section';
const BQ_CLICKED_SUBCATEGORY_PILL = 'clicked_on_subcategory_pill';
const BQ_CLICKED_SHOW_MORE_TALENTS = 'clicked_on_show_more_talents';
const BQ_VIEWED_TESTIMONIALS_SECTION = 'viewed_testimonials_section';
const BQ_CLICKED_TESTIMONIAL_CARD = 'clicked_on_testimonial_card';
const BQ_CLICKED_CLOSE = 'clicked_on_close';
const BQ_CLICKED_SEE_PORTFOLIO = 'clicked_on_see_portfolio';
const BQ_CLICKED_BECOME_SELLER_CTA = 'clicked_on_become_seller_cta';

const BQ_VIEWED_FAQ_SECTION = 'viewed_faq_section';
const BQ_CLICKED_FAQ_QUESTION = 'clicked_on_faq_question';
const BQ_VIEWED_BOTTOM_SEARCH_SECTION = 'viewed_bottom_search_section';
const BQ_FOCUS_IN_SEARCH_BY_SERVICE = 'focus_in_search_by_service';
const BQ_SUBMIT_MIRA_QUERY = 'submit_mira_query';
const BQ_CLICKED_SCHEDULE_CALL_WITH_SALES = 'clicked_on_schedule_call_with_sales';
const BQ_CLICKED_CATEGORY_SUBNAV = 'clicked_on_category_subnav';
const BQ_VIEWED_CATEGORY_SUBNAV = 'viewed_category_subnav';
const BQ_CLICKED_CATEGORY_TILE = 'clicked_on_category_tile';
const BQ_CLICKED_EXPLORE_CATEGORY = 'clicked_on_explore_category';
const BQ_CLICKED_HERO_SEARCH_TOGGLE = 'clicked_on_hero_search_toggle';
const BQ_VIEWED_AI_BANNER = 'viewed_ai_banner';
const BQ_CLICKED_FIND_AI_EXPERTS = 'clicked_on_find_ai_experts';

export {
    BQ_VIEWED_AI_BANNER,
    BQ_CLICKED_FIND_AI_EXPERTS,
    BQ_VIEWED_FAQ_SECTION,
    BQ_CLICKED_FAQ_QUESTION,
    BQ_VIEWED_BOTTOM_SEARCH_SECTION,
    BQ_FOCUS_IN_SEARCH_BY_SERVICE,
    BQ_SUBMIT_MIRA_QUERY,
    BQ_CLICKED_SCHEDULE_CALL_WITH_SALES,
    BQ_CLICKED_CATEGORY_SUBNAV,
    BQ_VIEWED_CATEGORY_SUBNAV,
    BQ_CLICKED_CATEGORY_TILE,
    BQ_CLICKED_EXPLORE_CATEGORY,
    BQ_CLICKED_HERO_SEARCH_TOGGLE,
    BQ_CLICKED_NAV_BAR_LINK,
    BQ_VIEWED_NAV_BAR,
    BQ_VIEWED_BUILD_DESIGN_MARKET_SECTION,
    BQ_CLICKED_BUILD_DESIGN_MARKET_SECTION,
    BQ_CLICKED_SUBCATEGORY_PILL,
    BQ_CLICKED_SHOW_MORE_TALENTS,
    BQ_VIEWED_TESTIMONIALS_SECTION,
    BQ_CLICKED_TESTIMONIAL_CARD,
    BQ_CLICKED_CLOSE,
    BQ_CLICKED_SEE_PORTFOLIO,
    BQ_CLICKED_BECOME_SELLER_CTA,
    BQ_CLICKED_QUICK_SEARCH_SUGGESTION,
    BQ_CLICKED_TRENDING_SUGGESTION,
    BQ_FOCUS_IN_HERO_SEARCH_BOX,
    BQ_LOHP_TEST_VIEW,
    BQ_CLICKED_GUEST_HOMEPAGE_CATEGORY_IMAGE,
    BQ_CLICKED_HOMEPAGE_LO_SEARCH_TAG,
    BQ_CLICKED_HOMEPAGE_LO_GET_STARTED,
    BQ_CLICKED_HOMEPAGE_LO_BUSINESS_SERVICES,
    BQ_CLICKED_BRAND_VIDEO_PREVIEW,
    BQ_SHOW_BRAND_VIDEO_THUMBNAIL,
    BQ_SHOW_BRAND_VIDEO_PLAYER,
    BQ_CLOSED_BRAND_VIDEO_PLAYER,
    BQ_CLICKED_BRAND_LANDING_PAGE_LINK,
    BQ_CLICKED_POPULAR_SERVICES_CAROUSEL,
    BQ_CLICKED_GETTING_STARTED,
    BQ_CLICKED_TESTIMONAILS_VIDEO,
    BQ_CLICKED_CTA_BANNER,
    BQ_HOVERED_USP,
    BQ_HOVERED_TESTIMONIALS_VIDEO,
    BQ_IMP_TOP_BANNER_IS_SHOWN,
    BQ_IMP_POPULAR_SERVICES_CAROUSEL_IS_SHOWN,
    BQ_IMP_CATEGORY_ICONS_IS_SHOWN,
    BQ_IMP_GETTING_STARTED_IS_SHOWN,
    BQ_IMP_USPSS_IS_SHOWN,
    BQ_IMP_LOHP_VIDEO_IS_SHOWN,
    BQ_IMP_FIP_IS_SHOWN,
    BQ_IMP_TESTIMONIALS_IS_SHOWN,
    BQ_IMP_GUIDES_IS_SHOWN,
    BQ_IMP_CTA_BANNER_IS_SHOWN,
    BQ_IMP_QUALITY_EXPERTS_BANNER_IS_SHOWN,
    BQ_CLICKED_QUALITY_EXPERTS_BANNER,
    BQ_CLICKED_USPSS_BUTTON,
    BQ_VIDEO_PLAY,
    BQ_VIDEO_PAUSE,
    BQ_POPULAR_SERVICE_CLICK_WEBSITE_DEVELOPMENT,
    BQ_POPULAR_SERVICE_CLICK_ARCHITECTURE_AND_INTERIOR,
    BQ_POPULAR_SERVICE_CLICK_VIDEO_EDITING,
    BQ_POPULAR_SERVICE_CLICK_LOGO_DESIGN,
    BQ_HOMEPAGE_CLICK,
    BQ_HOMEPAGE_IMP,
    BQ_POPULAR_SERVICE_CLICK_PRESENTATIONS_DESIGN,
    BQ_POPULAR_SERVICE_CLICK_VIDEO_UGC,
    BQ_POPULAR_SERVICE_CLICK_TIKTOK_SHOP,
    BQ_POPULAR_SERVICE_CLICK_NO_CODE,
    BQ_POPULAR_SERVICE_CLICK_BOOK_PUBLISHING,
    BQ_POPULAR_SERVICE_CLICK_AI_AUTOMATION,
};
